import { type NextPage } from 'next'
import curry from 'lodash.curry'

import { type WithDeusExMachinaProps } from '~/domains/platform/infra/deus-ex-machina/types'

import { SurveysProvider } from './contexts/surveys-triggers-context'
import { type DecodedTriggerPayload } from './entities/surveys/data-contracts'

export const withSurveys = curry(function (enableSurveys: boolean, Page: NextPage<WithDeusExMachinaProps>) {
  function WrappedPage({
    subject,
    entity,
    ...rest
  }: WithDeusExMachinaProps & { decodedTrigger?: DecodedTriggerPayload }) {
    if (!enableSurveys) {
      return <Page subject={subject} entity={entity} {...rest} />
    }
    return (
      <SurveysProvider document={entity.document} initialTriggers={rest.decodedTrigger}>
        <Page subject={subject} entity={entity} {...rest} />
      </SurveysProvider>
    )
  }

  WrappedPage.displayName = `withSurveys(${Page.displayName})`

  return WrappedPage
})
